export enum DaysOfWeek {
	Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday
}

export enum DaysOfWeekShort {
	sun, mon, tue, wed, thurs, fri, sat
}
